import { Theme } from './theme';

export const Background = Object.freeze({
  ColorDefault: Theme.ColorBackgroundPrimary,
  ColorMobile: Theme.ColorBackgroundSecondary,
  ColorDesktop: Theme.ColorBackgroundSecondary,
  ColorAccountMenu: Theme.ColorBackgroundSecondary,
});
